import React from 'react';
import { cn } from '@/utils/cn';
import SkeletonWrapper from './SkeletonWrapper';

function BannerSkeleton({
  className = '',
  showNextPrevBtnSkeleton = true,
  showSliderButtons = false,
}) {
  return (
    <section
      className={cn(
        'home-page-banner-skeleton animate-pulse bg-skeleton shadow-trending-categories-search relative w-full max-w-full',
        className,
      )}
    >
      {showNextPrevBtnSkeleton ? (
        <div className="absolute left-[50%] top-[50%] translate-y-[-50%] translate-x-[-50%] w-full">
          <div className="h-full container mx-auto flex justify-between items-center]">
            <div className="h-[24px] w-[24px] lg:h-[36px] lg:w-[36px] rounded-full bg-himalayan-poppy animate-pulse" />
            <div className="h-[24px] w-[24px] lg:h-[36px] lg:w-[36px] rounded-full bg-himalayan-poppy animate-pulse" />
          </div>
        </div>
      ) : null}

      {showSliderButtons ? (
        <div className="absolute left-[50%] bottom-[3%] lg:bottom-[5%] translate-y-[3%] lg:translate-y-[5%] translate-x-[-50%] w-full">
          <div className="container mx-auto flex items-center justify-center gap-x-2 lg:bg-white h-[14px] lg:h-[18px] w-[114px] lg:w-[142px] rounded-full">
            {/* active button */}
            <div className="flex-shrink-0 h-[6px] w-[18px] lg:h-[10px] lg:w-[30px] rounded-full bg-himalayan-poppy animate-pulse" />

            {/* inactive buttons */}
            <SkeletonWrapper renderTimes={3}>
              <div className="flex-shrink-0 h-[6px] w-[6px] lg:h-[10px] lg:w-[10px] rounded-full bg-himalayan-poppy animate-pulse" />
            </SkeletonWrapper>
          </div>
        </div>
      ) : null}
    </section>
  );
}

export default BannerSkeleton;
